import { createAPIConnection } from 'services';
import { requestHandler } from 'services/helpers';
import { GetModalDataResponse } from './interfaces';

const api = createAPIConnection('/modal');

export const getModalData = async (posId: string) =>
	requestHandler<GetModalDataResponse>(api.get(`/pos/${posId}`));